import { Injectable } from '@angular/core';

import { Auth } from 'src/providers/auth/auth';
import { AuthModalService } from 'src/shared/services/auth-modal.service';

@Injectable()
export class AuthGuard  {

  constructor(
    private auth: Auth,
    private authModalService: AuthModalService
  ) {}

  canActivate(): boolean {
    if (!this.auth.isAuthenticated()) {
      // App component shows mock dashboard + auth modal.
      // Just open the modal if it's not already open.
      this.authModalService.openAuthModal('signin');
      return false;
    }

    return true;
  }

}
